import { faMobileButton } from '@fortawesome/pro-regular-svg-icons/faMobileButton';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faBarsStaggered } from '@fortawesome/pro-regular-svg-icons/faBarsStaggered';
import { faCodeBranch } from '@fortawesome/pro-regular-svg-icons/faCodeBranch';
import { faChartNetwork } from '@fortawesome/pro-light-svg-icons/faChartNetwork';
export var primaryFilter = [
    {
        type: 'view',
        label: 'View',
        icon: faMobileButton,
    },
    {
        type: 'list',
        label: 'List',
        icon: faList,
    },
    {
        type: 'Menu',
        label: 'Main Menu',
        icon: faBars,
    },
    {
        type: 'submenu',
        label: 'Sub Menu',
        icon: faBarsStaggered,
    },
    {
        type: 'logic',
        label: 'Logic',
        icon: faCodeBranch,
    },
    {
        type: 'custom_logic',
        label: 'Custom Logic',
        icon: faChartNetwork,
    },
];
export var logicFilters = [
    {
        type: 'logic',
        label: 'Logic',
        icon: faCodeBranch,
    },
    {
        type: 'custom_logic',
        label: 'Custom Logic',
        icon: faChartNetwork,
    },
];
